module.exports = __webpack_public_path__ + "static/media/storico-richieste.1b1abf37.png";